<template>
  <div class="global-auth-box d-flex justify-center align-center" @click="show = false">
    <div class="g-auth-box" @click.stop>
      <div v-if="showForgot && false">
        <div class="page-title">Forgot Password</div>
        <div class="pax-field">
          <input type="text" placeholder="Email" v-model="forgot.email" @keyup.enter="sendForgot"
            autocomplete="one-time-code" />
        </div>
        <div class="error-msg" v-if="forgot.error">{{forgot.error}}</div>
        <div class="op-btn btn-md btn-block btn-success login-btn" @click="sendForgot">SEND FORGOT PASSWORD</div>
        <div class="text-center">
          <a @click="cancelForgot" href="javascript:;" class="cnl-btn">Cancel</a>
        </div>
      </div>

      <div v-else>
        <email-mobile-form v-show="!user.token"
          @loginUser="loginUser" @nonUser="nonUser"
          @getUserInfo="getUserInfo" @hideVeriForm="hideVeriForm"
        />
        <!-- <div class="page-title">Login</div>
        <div :class="['pax-field', {'has-error':login.error.fields.indexOf('email') > -1}]">
          <input type="text" placeholder="Email" v-model="login.email" @keyup.enter="submitLogin"
            autocomplete="one-time-code" />
        </div>
        <div :class="['pax-field', {'has-error':login.error.fields.indexOf('password') > -1}]">
          <input type="password" placeholder="Password" v-model="login.password"
            autocomplete="one-time-code" @keyup.enter="submitLogin" />
        </div>
        <div class="forgot-box"><span @click="initForgot">Forgot password?</span></div>

        <div class="error-msg" v-if="login.error.msg.length">
          <div v-for="(err, e) in login.error.msg" :key="e">- {{err}}</div>
        </div>

        <div class="op-btn btn-md btn-block btn-success login-btn" @click="submitLogin">LOGIN</div>

        <div class="no-account">
          Don't have an account?
          <a @click="initShowSignup">Sign Up</a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import uuidv4 from 'uuid/v4'
import mobileInput from '@/components/D2DOthers/MobileInput'
import EmailMobileForm from "./EmailMobileForm.vue"
import CreditCard from '@/modules/api/credit-card'
import WidgetSession from '@/modules/session'
import Credits from '@/modules/api/_credits'
const cookie = require('vue-cookie')

export default {
  name: 'auth-login',
  components: { mobileInput, EmailMobileForm },
  data () {
    return {
      forgot: {
        email: '',
        error: ''
      },
      login: {
        email: '',
        password: '',
        error: {
          fields: [],
          msg: []
        }
      },
      session: '',
      showForgot: false,
      forceProfileUpdate: false
    }
  },
  computed: {
    user () { return this.$store.state.user },
    auth () { return this.$store.state.global.auth },
    show: {
      get () { return this.auth.show },
      set (x) {
        if (this.auth.action === 'forceAuth') return
        this.$store.commit('global/setAuthData', {show: x})
      }
    }
  },
  methods: {
    loginUser (res) {
      let self = this
      self.$store.commit('user/setIsCorporate', false)
      if (res.error) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.login.error.msg.push(self.$t(res.error.message))
        return
      }
      self.$store.commit('global/setAuthData', {show: false})
      // self.show = false
      self.session.useToken(res.token) // Only save the token if successful
      self.$store.commit('user/setToken', res.token)
      res.bday = res.dateOfBirth
      res.country = res.userCountry
      res.passportNum = res.passportNum
      if (res.paxinfo) {
        res.title = res.paxinfo.title
        res.gender = res.paxinfo.gender
        self.$store.commit('user/setUserData', {
          address: res.paxinfo.address || '',
          city: res.paxinfo.city || '',
          zip: res.paxinfo.zip || ''
        })
      }
      self.$store.commit('user/setUserInfo', res)
      // self.getAddress(newUserToken)
      self.getCredits()
    },
    nonUser (res) {
      this.show = false
      let tmpAuthData = {
        step: 1,
        mobile: '',
        countryCode: '',
        email: ''
      }
      if (res.loginVia === 'email') tmpAuthData.email = res.email
      else {
        tmpAuthData.mobile = res.phone
        tmpAuthData.countryCode = res.countryCode
      }
      this.$store.commit('global/setAuthSignupData', tmpAuthData)
      this.$store.commit('global/setAuthData', {
        signupSelect: false,
        showSignup: true
      })
    },
    getUserInfo (token) {
      let self = this
      self.$sdk.get(self, `/me?token=${token}`, {}, res => {
        self.$store.commit('global/setAuthData', {show: false})
        if (res.error) {
          self.$store.commit('global/setAlertData', {show: true, message: res.error.message})
          return
        }
        res.token = token
        self.$root.$emit('applyLogin', res)
        self.$store.commit('user/setEmailSubscribed', res.emailSubscribed === 1)

        if (res.corporateProfile && res.corporateProfile.discountCode) {
          self.$root.$emit('redeemCode', {code: res.corporateProfile.discountCode})
        }
        self.$root.$emit('getCards')
      })
    },
    hideVeriForm () {
      console.log('hideVeriForm')
    },
    submitLogin () {
      let self = this
      let hasError = false
      let fields = ['email', 'password']
      self.login.error = {
        fields: [],
        msg: []
      }
      fields.forEach(f => {
        if (!self.login[f]) {
          hasError = true
          self.login.error.fields.push(f)
        }
      })
      if (self.login.error.fields.length) {
        self.login.error.msg.push('Please fill up the missing fields.')
      }
      if (hasError) return

      if (self.login.email.indexOf('@') === -1) {
        self.loginCorp()
        return
      }

      let newUserToken = this.session.generateUserToken(false)
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post(self, '/auth/login', {
        email: self.login.email,
        password: self.login.password,
        device: newUserToken,
        deviceType: 'web',
        d2d: 1
      }, res => {
        self.$store.commit('user/setIsCorporate', false)
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.login.error.msg.push(self.$t(res.error.message))
          return
        }
        self.$store.commit('global/setAuthData', {show: false})
        // self.show = false
        self.session.useToken(newUserToken) // Only save the token if successful
        self.$store.commit('user/setToken', newUserToken)
        res.bday = res.dateOfBirth
        res.country = res.userCountry
        res.passportNum = res.passportNum
        if (res.paxinfo) {
          res.title = res.paxinfo.title
          res.gender = res.paxinfo.gender
          self.$store.commit('user/setUserData', {
            address: res.paxinfo.address || '',
            city: res.paxinfo.city || '',
            zip: res.paxinfo.zip || ''
          })
        }
        self.$store.commit('user/setUserInfo', res)
        // self.getAddress(newUserToken)
        self.getCredits()
        // self.getCards()
      })
    },
    loginCorp () {
      let self = this
      let token = 'CORP-' + uuidv4()
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post(self, '/auth/login/corporate', {
        username: self.login.email,
        password: self.login.password,
        token: token
      }, res => {
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {show: true, message: res.error.message})
          return
        }
        self.$root.$emit('setSession', token)
        self.$store.commit('user/setToken', token)
        self.$store.commit('user/setUserInfo', {
          ID: res.id,
          email: res.contactEmail,
          firstName: res.name,
          lastName: '',
          phone: {
            number: res.contactPhone,
            code: res.countryCode || ''
          },
          bday: res.dateOfBirth,
          country: res.userCountry,
          passportNum: res.passportNum
        })

        self.$store.commit('user/setIsCorporate', true)
        self.$store.commit('user/setCorporateData', {
          name: res.name,
          logo: res.logoUrl
        })
        if (res.discountCode) self.$root.$emit('redeemCode', {code: res.discountCode})

        self.show = false
        self.getPaxInfo(token)
      })
    },
    getPaxInfo (token) {
      let self = this
      self.$sdk.get(self, '/me', {token: token}, res => {
        if (res.error) {
          self.getCredits()
          return
        }

        res.bday = res.dateOfBirth
        res.country = res.userCountry
        res.passportNum = res.passportNum
        if (res.paxinfo) {
          res.title = res.paxinfo.title
          res.gender = res.paxinfo.gender
          self.$store.commit('user/setUserData', {
            address: res.paxinfo.address || '',
            city: res.paxinfo.city || '',
            zip: res.paxinfo.zip || ''
          })
        }
        self.$store.commit('user/setUserInfo', res)

        if (!res.paxinfo) self.forceProfileUpdate = true
        else {
          self.$store.commit('user/setUserData', {
            address: res.paxinfo.address,
            city: res.paxinfo.city,
            zip: res.paxinfo.zip
          })
        }
        self.getCredits()
      })
    },
    // getAddress (token) {
    //   let self = this
    //   self.$sdk.get(self, '/me/locations', {token: token}, res => {
    //     self.getCredits()
    //     if (res.error) return
    //     let home = res.home
    //     self.$store.commit('user/setUserData', {
    //       address: home && home.addressLine1 ? home.addressLine1 : '',
    //       city: home && home.city ? home.city : '',
    //       zip: home && home.zipCode ? home.zipCode : ''
    //     })
    //   }, '1.1')
    // },
    getCredits () {
      let self = this
      Credits.get(self, {token: self.user.token}, () => {
        self.getCards()
      })
    },
    getCards () {
      let self = this
      CreditCard.getCards(self, self.user.token, r => {
        self.$store.commit('global/setLoaderData', {show: false})

        if (self.forceProfileUpdate) {
          self.$store.commit('global/setUserInfoData', {
            show: true,
            forceUpdateProfile: true
          })
          self.forceProfileUpdate = false
          return
        }
        if (self.auth.action && self.auth.action !== 'forceAuth') {
          self.$router.push(self.auth.action)
          self.$store.commit('global/setAuthData', {action: ''})
        }
      })
    },
    logout () {
      this.session.destroy()
      this.$store.commit('user/reset')
      cookie.delete('userToken')
      if (this.$refs.userMobile && this.$refs.userMobile.changePhoneNumber()) {
        this.$refs.userMobile.changePhoneNumber()
      }
      this.$store.commit('cards/setCardData', {
        lastUserID: '',
        list: []
      })
    },
    initForgot () {
      this.login.error.fields = []
      this.login.error.msg = []
      this.showForgot = true
    },
    sendForgot () {
      let self = this
      let hasError = false
      self.forgot.error = ''
      if (!self.forgot.email) {
        hasError = true
        self.forgot.error = 'Please input your email.'
      }
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (self.forgot.email && !pattern.test(self.forgot.email)) {
        hasError = true
        self.forgot.error = self.$t('common.invalidEmail')
      }
      if (hasError) return

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('self', '/me/forgotpassword', {
        email: self.forgot.email,
        brand: 'dd',
        d2d: 1
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (res.success) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Forgot password email sent.'
          })
          self.showForgot = false
          self.emailForgot = ''
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: res.message
        })
      }, '')
    },
    cancelForgot () {
      this.showForgot = false
      this.forgot.error = ''
    },
    initShowSignup () {
      this.$store.commit('global/setAuthData', {
        show: false,
        signupSelect: true
        // showSignup: true
      })
    }
  },
  mounted () {
    this.session = new WidgetSession(this)
  }
}
</script>

<style lang="scss" scoped>
.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;
}
.g-auth-box{
  background: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0,0,0, .3);
  padding: 20px;
  width: 100%;
  max-width: 500px;
}
.page-title{
  font-size: 21px;
  font-weight: 600;
  padding: 15px 0;
  text-align: center;
}
.pax-field{
  margin-bottom: 10px;

  input{
    padding: 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
  }
  &.has-error{
    border:1px solid #EB5837;
  }
}
.forgot-box{
  text-align: left;
  color: #777;
  text-decoration: underline;

  span{
    cursor: pointer;
  }
}
.login-btn{
  margin: 20px 0;
}
.error-msg{
  border: 1px solid #f00;
  background: #fadfdf;
  color: #f00;
  padding: 5px;
  line-height: 1.3;
  border-radius: 2px;
  margin: 20px 0;
  text-align: left;

  a{
    color: #285cc7;
    font-weight: 600;
  }
}
.no-account{
  text-align: center;

  a{
    color: #ff9c09!important;
    font-weight: 600;
    cursor: pointer;
  }
}
.signup-btn{
  margin: 20px 0;
}

.cnl-btn{
  color: #888;
}
</style>



// WEBPACK FOOTER //
// GlobalLogin.vue?832e94c4